// extracted by mini-css-extract-plugin
module.exports = {"buttons":"SetupRecs_buttons__1Eglz","page":"SetupRecs_page__1FjzP"};